import _ from 'lodash'

const meetingPlatformTroubleshootingPopUp = (webexLink, session, setState) => {
  let content = ''
  let trouble = ''
  let platform = session.virtual_platform_name ? session.virtual_platform_name : 'Meeting'
  let steps = ''
  let stepList = ''
  switch(session.virtual_platform_key) {
  case 'virtual_platform_webex_events':
    steps = ['Select “Join Meeting” from the Virtual Portal. This will launch a separate WebEx browser window as well as a WebEx session.', 'Click “Join Event” in WebEx to join the session.', 'Depending on session type:<ul><li>For boardrooms, you will have the ability to control your own audio and video utilizing the buttons at the bottom of the WebEx window.</li><li>For town halls and keynotes, attendees do not have video capabilities and are automatically muted. You can submit questions or comments via the chat box in the bottom right corner. Please send chat messages to “All Attendees.”</li></ul>']
    _.each(steps, function(step){
      stepList += `<li>${step}</li>`
    })
    trouble = `<h4>Troubleshooting Steps for ${platform}</h4>
              <ol>
              ${stepList}
              </ol>`
    break
  case 'virtual_platform_shindig':
    steps = ['Ensure you have exited out of other video chat services.', 'Select “Join session” from the Virtual Portal. This will launch a separate browser tab/window on the Shindig platform.', 'Fill in your name and email address, then click “Enter the event.”', 'Please Note: Chrome provides the best experience, but other browsers will work as well. Please review the <a href="https://urldefense.com/v3/__https:/www.shindig.com/faq/__;!!NmrTbz2Y!mlOjsnETI4eW8-ircukhDH3cgOFdTUeYScJFQGLkT-8fAz1MBTBRvKqcWx5b0tQahUhA6kLTfCPf$" target="_blank">Shindig FAQ</a> and <a href="https://urldefense.com/v3/__https:/drive.google.com/file/d/1B8AfDaeUiD72pg8H3lNOZZ7siLCCxRWK/view?usp=sharing__;!!NmrTbz2Y!mlOjsnETI4eW8-ircukhDH3cgOFdTUeYScJFQGLkT-8fAz1MBTBRvKqcWx5b0tQahUhA6vAErFDu$" target="_blank">Shindig Tutorial</a> if you’re experiencing issues with your device accessing your camera or mic. If you have an ad-blocker, go to <a href="https://shindig.com" target="_blank">Shindig.com</a>, click on your ad-blocker and select "trust site" or "do not run on all pages on this site.”']
    _.each(steps, function(step){
      stepList += `<li>${step}</li>`
    })
    trouble = `<h4>Troubleshooting Steps for ${platform}</h4>
              <p>To join this Networking Session:</p>
              <ol>
              ${stepList}
              </ol>`
    break
  default:
    trouble = `<h4>Troubleshooting Steps for ${platform}</h4>`
  }
  let url = ''
  if (webexLink) {
    url = `<p>Meeting URL: <a href=${webexLink} target='_blank'>${webexLink}</a></p>`
  } else if (session.virtual_platform_meeting_url) {
    url = `<p>Meeting URL: <a href=${session.virtual_platform_meeting_url} target='_blank'>${session.virtual_platform_meeting_url}</a></p>`
  }
  let id = session.virtual_platform_meeting_code ? `<p>Meeting ID: ${session.virtual_platform_meeting_code}</p>` : ''
  let password = session.virtual_platform_meeting_password ? `<p>Meeting Password: ${session.virtual_platform_meeting_password}</p>` : ''
  content = `<h4>${platform} Details</h4>
              ${url}${id}${password}
              <hr> ${trouble}`

  setState({
    genericModalIsOpen: true,
    genericModalContent: content,
    genericModalCustomClass: 'troubleshooting'
  })
}

export default meetingPlatformTroubleshootingPopUp